// src/pages/LoginPage.jsx
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { requestAndSaveToken } from "../utils/fcm";

const LoginPage = () => {
  const { user, signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const referrerId = searchParams.get("ref");

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  const handleSignIn = async () => {
    try {
      await signInWithGoogle(referrerId);
      // 🔔 Register FCM token after successful login
      if (user) {
        await requestAndSaveToken(user);
      }
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-100 to-green-50 flex items-center justify-center px-4">
      <div className="bg-white shadow-2xl rounded-3xl p-10 max-w-md w-full text-center border border-green-100">
        <img
          src="/logo192.png"
          alt="JR-Home Made Foods"
          className="h-20 w-20 mx-auto mb-4 drop-shadow-lg"
        />
        <h1 className="text-3xl font-extrabold text-green-700 mb-2">
          Welcome to JR-Home Made Foods
        </h1>
        <p className="text-gray-600 mb-6">
          Sign in to access your personalized experience and manage your subscriptions securely 🍲
        </p>

        {referrerId && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
            <p className="text-sm text-green-700">
              🎁 You were invited by a friend! Sign up to get started.
            </p>
          </div>
        )}

        <button
          onClick={handleSignIn}
          className="flex items-center justify-center gap-3 bg-green-600 hover:bg-green-700 text-white px-6 py-3 w-full rounded-full text-base font-semibold shadow-md transition-all duration-200 mb-4"
        >
          <svg
            className="w-5 h-5"
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M44.5 20H24v8.5h11.9C34.5 33.2 30 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8.1 3.1l6-6C34.6 5.1 29.6 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21c10.5 0 19.5-7.6 21-18 0.2-1.3 0.5-2.7 0.5-4z"
              fill="#FFC107"
            />
            <path
              d="M6.3 14.1l6.6 4.8C14.5 15.6 18.9 13 24 13c3.1 0 5.9 1.2 8.1 3.1l6-6C34.6 5.1 29.6 3 24 3 16.3 3 9.6 7.5 6.3 14.1z"
              fill="#FF3D00"
            />
            <path
              d="M24 45c5.4 0 10.4-2 14.1-5.2l-6.6-5.6C29.4 36.4 26.8 37 24 37c-6.1 0-10.6-3.8-12.5-9.1l-6.5 5C8.3 41.5 15.6 45 24 45z"
              fill="#4CAF50"
            />
            <path
              d="M44.5 20H24v8.5h11.9c-1.2 3.2-3.5 5.9-6.4 7.7l6.6 5.6c-1.7 1.6 8.4-5.8 8.4-17.8 0-1.3-0.1-2.6-0.4-3.9z"
              fill="#1976D2"
            />
          </svg>
          Sign in with Google
        </button>

        <button
          onClick={() => navigate("/")}
          className="text-green-600 hover:text-green-700 underline text-sm"
        >
          ← Back to Home
        </button>

        <p className="text-xs text-gray-400 mt-6">
          By signing in, you agree to our{" "}
          <a
            href="/terms-and-conditions"
            className="text-green-600 underline hover:text-green-700"
          >
            Terms
          </a>{" "}
          and{" "}
          <a
            href="/privacy-policy"
            className="text-green-600 underline hover:text-green-700"
          >
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
